import React from "react";
import "./experience.css";
import { BsPatchCheckFill } from "react-icons/bs";

const Experience = () => {
  return (
    <section id="experience">
      <h5>Habilidades</h5>
      <h2>Mi Experiencia</h2>

      <div className="container experience__container">
        <div className="experience_frontend">
          <h3>Experiencia Laboral</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Eventos Novias 2019</h4>
                <small className="experience_details-small">
                  <i>Hotel Intercontinental</i>
                </small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>
                  Producción <i>MDZ Vendimia</i>
                </h4>
                <small className="experience_details-small">
                  2018 para <i>Flor Raviolo.</i>
                </small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>
                  Producción para <br />
                  15 años
                  <i> Ricky Videla</i>
                </h4>
                <small className="experience_details-small">
                  2019/2020 <i>Hotel Hyatt</i> para <i>Flor Raviolo</i>
                </small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>
                  Producción 2020 <br />
                  para <i>Alabama Digital</i>
                </h4>
                <small className="experience_details-small">
                  bodega <i>Susana Balbo Wines.</i>
                </small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>
                  Organización de <br />
                  <i>Destination Wedding</i>
                </h4>
                <small className="experience_details-small">
                  Beauty Novias 2020-2022
                </small>
              </div>
            </article>
          </div>
        </div>
        <div className="experience_backend">
          <h3>Habilidades Profesionales</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Productos cosméticos.</h4>
                <small className="experience_details-small">
                  Especialización avanzada.
                </small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Piel joven y madura.</h4>
                <small className="experience_details-small">
                  Experiencia Avanzada.
                </small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>
                  Aplicación de cosméticos <br />y tratamientos de piel.
                </h4>
                <small className="experience_details-small">
                  Especialización avanzada.
                </small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>
                  Organización del trabajo <br />y gestión de tiempo
                </h4>
                <small className="experience_details-small">
                  Muy eficiente.
                </small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Orientación hacia el cliente.</h4>
                <small className="experience_details-small">Muy buena.</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>
                  Profesionalidad <br />
                  en el desarrollo de las <br /> actividades laborales.
                </h4>
                <small className="experience_details-small">Alta.</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
